/**
 * @generated SignedSource<<e587eac1c2d3d8ba63ee8c87db7ab455>>
 * @relayHash 12d38f3abe5e2698472ede1e15c02756
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3fb6055fa76c3df947e941315b97b2034b76636ee0bacb920f1298a1de0c1207

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useUpdateContentPropertyPageCreateMutation$variables = {
  pageId: string;
  propertyKey: string;
  propertyValue: string;
};
export type useUpdateContentPropertyPageCreateMutation$data = {
  readonly confluence: {
    readonly createPageProperty: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly pageProperty: {
        readonly key: string;
        readonly value: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useUpdateContentPropertyPageCreateMutation = {
  response: useUpdateContentPropertyPageCreateMutation$data;
  variables: useUpdateContentPropertyPageCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyValue"
},
v3 = [
  {
    "concreteType": "ConfluenceMutationApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "propertyKey"
              },
              {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "pageId"
              },
              {
                "kind": "Variable",
                "name": "value",
                "variableName": "propertyValue"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "ConfluenceCreatePagePropertyPayload",
        "kind": "LinkedField",
        "name": "createPageProperty",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "ConfluencePageProperty",
            "kind": "LinkedField",
            "name": "pageProperty",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateContentPropertyPageCreateMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateContentPropertyPageCreateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "12d38f3abe5e2698472ede1e15c02756",
    "id": "3fb6055fa76c3df947e941315b97b2034b76636ee0bacb920f1298a1de0c1207",
    "metadata": {},
    "name": "useUpdateContentPropertyPageCreateMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateContentPropertyPageCreateMutation($propertyKey:String!,$pageId:ID!,$propertyValue:String!){confluence{createPageProperty(input:{key:$propertyKey,pageId:$pageId,value:$propertyValue}){success,pageProperty{key,value},errors{message}}}}"
  }
};
})();

(node as any).hash = "e0b2f2f293e8f62e2dcc6d87c5900818";

export default node;
